import React from 'react';
import { connect } from 'react-redux'
import Select from '@components/Select/Select';
import StepTitle from "@components/StepTitle/StepTitle";
import './JobTypes.scss';
import { useDispatch } from "react-redux";
import { updateForm } from "@actions/formActions"

const JobTypes = (props) => {

    const dispatch = useDispatch();

    const onClick = (type) => {
        dispatch(updateForm({ type: 'date', data: null }));
        dispatch(updateForm({ type: 'time', data: null }));
        dispatch(updateForm({ type: 'dateNavDay', data: null }));
        props.onSelectedJobType(type)
    }

    return (
        <div className="job-types">
            <StepTitle title="What service do you need?"/>
            <div className="job-types-options">
                {props.jobTypes.map((jobType) =>
                    <Select
                        key={jobType.id}
                        item={jobType}
                        onClick={(type) => onClick(type)}
                        isSelected={jobType.id === props.selectedJobType}
                    />
                )}

            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    selectedJobType: state.selectedJobType,
})

export default connect(mapStateToProps)(JobTypes)

